<micro-select-combo #sel
              placeholder="SMSC Bind"
              routerBase="smsc/smscBinds"
              [(id)]="smscBindId"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
              [blur]="onTouched"
>
</micro-select-combo>
